import { Controller } from "@hotwired/stimulus"

// Admin Role Manager Controller
// Handles dynamic show/hide of survey assignments based on admin role selection
export default class extends Controller {
  static targets = ["assignmentsSection", "noAssignmentsMessage", "submitSection"]

  connect() {
    console.log("Admin role manager controller connected")

    // Find the role select element and attach change listener
    this.roleSelect = this.element.querySelector('select[name*="[role]"]')
    if (this.roleSelect) {
      this.roleSelect.addEventListener('change', this.handleRoleChange.bind(this))

      // Set initial state based on current role
      this.updateAssignmentVisibility()
    }
  }

  disconnect() {
    if (this.roleSelect) {
      this.roleSelect.removeEventListener('change', this.handleRoleChange.bind(this))
    }
  }

  handleRoleChange(event) {
    this.updateAssignmentVisibility()
  }

  updateAssignmentVisibility() {
    const selectedRole = this.roleSelect?.value
    const isAssignable = selectedRole === 'assignable'

    // Show/hide assignments section
    if (this.hasAssignmentsSectionTarget) {
      this.assignmentsSectionTarget.style.display = isAssignable ? 'block' : 'none'

      // If showing assignments for the first time and there are no existing assignments,
      // make sure the user can add new ones
      if (isAssignable) {
        const existingRows = this.assignmentsSectionTarget.querySelectorAll('.assignment-row')
        const addButton = this.assignmentsSectionTarget.querySelector('button[data-action*="addAssignment"]')

        // If no existing assignments and we have an add button, ensure it's visible
        if (existingRows.length === 0 && addButton) {
          console.log('No existing assignments found, ensuring add button is visible')
        }
      }
    }

    // Show/hide no assignments message
    if (this.hasNoAssignmentsMessageTarget) {
      this.noAssignmentsMessageTarget.style.display = isAssignable ? 'none' : 'block'
    }

    // Update submit button text
    if (this.hasSubmitSectionTarget) {
      const submitButton = this.submitSectionTarget.querySelector('input[type="submit"]')
      if (submitButton) {
        submitButton.value = isAssignable ?
          'Update Admin & Survey Assignments' :
          'Update Admin'
      }
    }

    console.log(`Role changed to: ${selectedRole}, assignments visible: ${isAssignable}`)
  }
}
